import React, { useEffect, useState } from 'react'
import { customStyle } from '../../Components/Style'
import { useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import "../../Assets/Css/EditProfile.scss"
import Select from 'react-select'
import axios from 'axios'

const initialState = {
     title: null,
     givenTo: null,
     name: '',
     notes: '',
     clientInvoices: []
}

const Department = [
     { value: "Intern", label: "Intern" },
     { value: "Design", label: "Design" },
     { value: "Development", label: "Development" },
     { value: "Full Stack Developer", label: "Full Stack Developer" },
     { value: "Frontend Developer", label: "Frontend Developer" },
     { value: "Backend Developer", label: "Backend Developer" },
     { value: "Team Leader", label: "Team Leader" },
     { value: "HR", label: "HR" },
];

const Designation = [
     { value: "Director", label: "Director" },
     { value: "Team Lead", label: "Team Lead" },
     { value: "HR", label: "HR" },
     { value: "Designer", label: "Designer" },
     { value: "Developer", label: "Developer" },
];

const Gender = [
     { value: "Male", label: "Male" },
     { value: "Female", label: "Female" },
     { value: "Other", label: "Other" },
];

const EmployeeType = [
     { value: "Full Time", label: "Full Time" },
     { value: "Part Time", label: "Part Time" },
     { value: "On Contract", label: "On Contract" },
     { value: "Internship", label: "Internship" },
     { value: "Trainee", label: "Trainee" },
     { value: "Ex-Employee", label: "Ex-Employee" },
];

const MaritalStatus = [
     { value: "Married", label: "Married" },
     { value: "UnMarried", label: "UnMarried" },
];

const EditProfile = (props) => {
     const [aniversary, setmrgAniversary] = useState(initialState);
     const [department, setDepartment] = useState(initialState);
     const [countries, setCountries] = useState([]);
     const [designation, setDesignation] = useState(initialState);
     const [gender, setGender] = useState(initialState);
     const [employeeType, setEmployeeType] = useState(initialState);
     const [maritalStatus, setMaritalStatus] = useState(initialState);
     const [joiningDate, setJoiningDate] = useState(initialState);
     const [workAniversaryDate, setWorkAniversaryDate] = useState(initialState);
     const [noticePeriodStartDate, setNoticePeriodStartDate] = useState(initialState);
     const [noticePeriodEndDate, setNoticePeriodEndDate] = useState(initialState);
     const [probationPeriodEndDate, setProbationPeriodEndDate] = useState(initialState);
     const [dob, setDob] = useState(initialState);

     const navigate = useNavigate();

     const handleNavigate = () => {
          navigate('/employees/view/profile');
     }

     useEffect(() => {
          const fetchCountries = async () => {
               try {
                    const response = await axios.get('https://restcountries.com/v3.1/all');
                    const countryOptions = response.data.map(country => ({
                         value: country.cca2,
                         label: country.name.common
                    }));
                    setCountries(countryOptions);
               } catch (error) {
                    console.error('Error fetching country data:', error);
               }
          };

          fetchCountries();
     }, []);

     return (
          <div className="edit-profile-main">
               <div className="page-title">
                    <h4>Edit Profile</h4>
                    <div className="edit-btn">
                         <button className="custom-btn" onClick={handleNavigate}>
                              {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Save"}
                         </button>
                    </div>
               </div>
               <div className="content-part">
                    <div className="row">
                         <div className="col-lg-12">
                              <div className="common-card">
                                   <div className="custom-row">
                                        <div className="row">
                                             <div className="col-lg-6">
                                                  <div className="input-group">
                                                       <h6 className='label'>Full Name</h6>
                                                       <input type="text" className="input-css" name='fullname' />
                                                  </div>
                                             </div>

                                             <div className="col-lg-6">
                                                  <div className="input-group">
                                                       <h6 className='label'>Department</h6>
                                                       <Select
                                                            options={Department}
                                                            styles={{
                                                                 ...customStyle,
                                                                 menu: (provided) => ({
                                                                      ...provided,
                                                                      zIndex: 2,
                                                                 }),
                                                            }}
                                                            value={department.givenTo}
                                                            onChange={(val) => {
                                                                 setDepartment((preVal) => ({
                                                                      ...preVal,
                                                                      givenTo: val
                                                                 }))
                                                            }}
                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>email</h6>
                                                       <input type="email" className="input-css" name='email' />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>Country</h6>
                                                       <Select
                                                            options={countries}
                                                            styles={{
                                                                 ...customStyle,
                                                                 menu: (provided) => ({
                                                                      ...provided,
                                                                      zIndex: 2,
                                                                 }),
                                                            }}
                                                            value={countries.givenTo}
                                                            onChange={(val) => {
                                                                 setCountries((preVal) => ({
                                                                      ...preVal,
                                                                      givenTo: val
                                                                 }));
                                                            }}
                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>Designation</h6>
                                                       <Select
                                                            options={Designation}
                                                            styles={{
                                                                 ...customStyle,
                                                                 menu: (provided) => ({
                                                                      ...provided,
                                                                      zIndex: 2,
                                                                 }),
                                                            }}
                                                            value={designation.givenTo}
                                                            onChange={(val) => {
                                                                 setDesignation((preVal) => ({
                                                                      ...preVal,
                                                                      givenTo: val
                                                                 }))
                                                            }}
                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>Gender</h6>
                                                       <Select
                                                            options={Gender}
                                                            styles={{
                                                                 ...customStyle,
                                                                 menu: (provided) => ({
                                                                      ...provided,
                                                                      zIndex: 2,
                                                                 }),
                                                            }}
                                                            value={gender.givenTo}
                                                            onChange={(val) => {
                                                                 setGender((preVal) => ({
                                                                      ...preVal,
                                                                      givenTo: val
                                                                 }))
                                                            }}
                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>Address</h6>
                                                       <input type="text" className="input-css" name='address' />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>Employee Type</h6>
                                                       <Select
                                                            options={EmployeeType}
                                                            styles={{
                                                                 ...customStyle,
                                                                 menu: (provided) => ({
                                                                      ...provided,
                                                                      zIndex: 2,
                                                                 }),
                                                            }}
                                                            value={employeeType.givenTo}
                                                            onChange={(val) => {
                                                                 setEmployeeType((preVal) => ({
                                                                      ...preVal,
                                                                      givenTo: val
                                                                 }))
                                                            }}
                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>mobile number</h6>
                                                       <input type="text" className="input-css" name='department' />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>language</h6>
                                                       <input type="text" className="input-css" name='department' />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>joining date</h6>
                                                       <DatePicker
                                                            styles={customStyle}
                                                            selected={joiningDate.name ? new Date(joiningDate.name) : null}
                                                            onChange={(date) => {
                                                                 setJoiningDate((preVal) => ({
                                                                      ...preVal,
                                                                      name: date.toISOString().split('T')[0],
                                                                 }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            name="transaction_date"

                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>work anniversary Date</h6>
                                                       <DatePicker
                                                            styles={customStyle}
                                                            selected={workAniversaryDate.name ? new Date(workAniversaryDate.name) : null}
                                                            onChange={(date) => {
                                                                 setWorkAniversaryDate((preVal) => ({
                                                                      ...preVal,
                                                                      name: date.toISOString().split('T')[0],
                                                                 }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            name="transaction_date"

                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>emergency contact</h6>
                                                       <input type="number" className="input-css" name='emergency-contact' />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>slack ID</h6>
                                                       <input type="text" className="input-css" name='department' />
                                                  </div>
                                             </div>


                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>notice period Start Date</h6>
                                                       <DatePicker
                                                            styles={customStyle}
                                                            selected={noticePeriodStartDate.name ? new Date(noticePeriodStartDate.name) : null}
                                                            onChange={(date) => {
                                                                 setNoticePeriodStartDate((preVal) => ({
                                                                      ...preVal,
                                                                      name: date.toISOString().split('T')[0],
                                                                 }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            name="transaction_date"

                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>notice period end date</h6>
                                                       <DatePicker
                                                            styles={customStyle}
                                                            selected={noticePeriodEndDate.name ? new Date(noticePeriodEndDate.name) : null}
                                                            onChange={(date) => {
                                                                 setNoticePeriodEndDate((preVal) => ({
                                                                      ...preVal,
                                                                      name: date.toISOString().split('T')[0],
                                                                 }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            name="transaction_date"

                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>probation period end date</h6>
                                                       <DatePicker
                                                            styles={customStyle}
                                                            selected={probationPeriodEndDate.name ? new Date(probationPeriodEndDate.name) : null}
                                                            onChange={(date) => {
                                                                 setProbationPeriodEndDate((preVal) => ({
                                                                      ...preVal,
                                                                      name: date.toISOString().split('T')[0],
                                                                 }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            name="transaction_date"

                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>date of birth</h6>
                                                       <DatePicker
                                                            styles={customStyle}
                                                            selected={dob.name ? new Date(dob.name) : null}
                                                            onChange={(date) => {
                                                                 setDob((preVal) => ({
                                                                      ...preVal,
                                                                      name: date.toISOString().split('T')[0],
                                                                 }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            name="transaction_date"

                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>


                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>marriage anniversary</h6>
                                                       <DatePicker
                                                            styles={customStyle}
                                                            selected={aniversary.name ? new Date(aniversary.name) : null}
                                                            onChange={(date) => {
                                                                 setmrgAniversary((preVal) => ({
                                                                      ...preVal,
                                                                      name: date.toISOString().split('T')[0],
                                                                 }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            name="transaction_date"

                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>


                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>Marital Status</h6>
                                                       <Select
                                                            options={MaritalStatus}
                                                            styles={{
                                                                 ...customStyle,
                                                                 menu: (provided) => ({
                                                                      ...provided,
                                                                      zIndex: 2,
                                                                 }),
                                                            }}
                                                            value={maritalStatus.givenTo}
                                                            onChange={(val) => {
                                                                 setMaritalStatus((preVal) => ({
                                                                      ...preVal,
                                                                      givenTo: val
                                                                 }))
                                                            }}
                                                            theme={(theme) => ({
                                                                 ...theme,
                                                                 colors: {
                                                                      ...theme.colors,
                                                                      primary25: "#5757fe",
                                                                      primary: "#5757fe",
                                                                 },
                                                            })}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="col-lg-4">
                                                  <div className="input-group">
                                                       <h6 className='label'>skills</h6>
                                                       <input type="text" className="input-css" name='maritalStatus' />
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     )
}

export default EditProfile;